import api from '@/pages/app/xhsAgency/publishStatistics/api.js';

export default { ...api };
